import BaseAPI from "@/apis/base/base-api";

class ResourceAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Resource";
  controllerName = "resource";

  /**
   * Đồng bộ resource tiêng việt
   */
  sync(parameter) {
    const me = this;
    let request = {
      url: me.getAPIUrl(),
      data: parameter,
    };

    return this.postAsync(request);
  }

  /**
   * Đọc theo ngôn ngữ
   */
  pull(lang) {
    const me = this;
    let request = {
      url: [me.getAPIUrl(), lang].join("/"),
    };

    return this.getAsync(request);
  }
}

export default new ResourceAPI();
